import { render, staticRenderFns } from "./productbuy.vue?vue&type=template&id=2ad80071&scoped=true"
import script from "./productbuy.vue?vue&type=script&lang=js"
export * from "./productbuy.vue?vue&type=script&lang=js"
import style0 from "./productbuy.vue?vue&type=style&index=0&id=2ad80071&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad80071",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ad80071')) {
      api.createRecord('2ad80071', component.options)
    } else {
      api.reload('2ad80071', component.options)
    }
    module.hot.accept("./productbuy.vue?vue&type=template&id=2ad80071&scoped=true", function () {
      api.rerender('2ad80071', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/productbuy.vue"
export default component.exports